import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import type {
	GetRefundProcedureTherapies,
	GetRefundProcedureTherapiesParams,
	GetRefundProcedureTherapiesResponse,
} from 'domain/usecases/private/refund/request/get-procedure-therapies';

export class RemoteRefundGetProcedureTherapies implements GetRefundProcedureTherapies {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundProcedureTherapiesResponse>,
	) {}

	async get({
		signal,
		...params
	}: GetRefundProcedureTherapiesParams): Promise<GetRefundProcedureTherapiesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
